import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold tracking-tight whitespace-nowrap cursor-pointer">
              Pandabuy<span className="text-primary-400">Spreadsheet</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-xs">
              The ultimate curated and continuously updated shopping spreadsheet for fashion enthusiasts. Find the best deals on shoes, clothing, accessories and more — all verified by our community.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50 mb-5">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors">Home</Link>
              <Link to="/guide/pandabuy-sheet-guide" className="text-sm text-foreground-300 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors">SEO Guide</Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors">Main Store</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50 mb-5">Top Categories</h4>
            <div className="flex flex-col gap-3">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50 mb-5">More Categories</h4>
            <div className="flex flex-col gap-3">
              {categories.slice(6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-foreground-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} PandabuySpreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            PandabuySpreadsheet is an informational platform. We do not sell products. All purchases are made through third-party platforms.
          </p>
        </div>
      </div>
    </footer>
  );
}